import React, { useRef, useState } from "react";
import "../assets/css/PricingPage.css";
import Tick_image from "../assets/images/Pricing_images/Tick.svg";
import "react-international-phone/style.css";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import axios from "axios";
import { Link } from "react-router-dom";
import TurnstileWidget from "./TurnstileWidget";


const PricingPage = () => {
  const [seletedValue, setSeletedValue] = useState("");
  const [price, setPrice] = useState("");
  const formref=useRef(null);
  const ScrollToForm=()=>{
    if(formref.current)
    {
        formref.current.scrollIntoView({ behavior:"smooth" });
    }
  }



  const handleChangeSelect = (event) => {
    const val = event.target.value;
    setSeletedValue(val);
    if (val === "10") {
      setPrice("$590");
    } else if (val === "25") {
      setPrice("$1390");
    } else if (val === "50") {
      setPrice("$2490");
    } else if (val === "75") {
      setPrice("$2990");
    } else if (val === "100") {
      setPrice("$3590");
    } else if (val === "More Network") {
      setPrice("More Network");
    } else {
      setPrice("");
    }
  };
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",
    is_msp: "",
    number_of_organizations: "",
    number_of_networks: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const [turnstileKey, setTurnstileKey] = useState(0);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };
  const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
  setErrors((prev) => {
    const newErrors = { ...prev };

    if (name === "firstName" && value.trim() !== "") {
      delete newErrors.firstName;
    }
    if (name === "lastName" && value.trim() !== "") {
      delete newErrors.lastName;
    }
    if (name === "email" && /\S+@\S+\.\S+/.test(value)) {
      delete newErrors.email;
    }
    if (name === "company" && value.trim() !== "") {
      delete newErrors.company;
    }
    if (name === "is_msp" && value.trim() !== "") {
      delete newErrors.is_msp;
    }
    if (name === "number_of_organizations" && /^\d+$/.test(value)) {
      delete newErrors.number_of_organizations;
    }
    if (name === "number_of_networks" && /^\d+$/.test(value)) {
      delete newErrors.number_of_networks;
    }
    if (name === "message" && value.trim() !== "") {
      delete newErrors.message;
    }

    return newErrors;
  });
};


  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = "First Name is required.";
    if (!formData.lastName.trim())
      newErrors.lastName = "Last Name is required.";
    if (!formData.company.trim()) newErrors.company = "Company is required.";
    if (!formData.is_msp.trim()) newErrors.is_msp = "Choose an option.";
    if (!formData.phone || formData.phone.trim() === "") {
  newErrors.phone = "Enter a phone number.";
} else {
  const phoneNumber = parsePhoneNumberFromString("+" + formData.phone);
  if (!phoneNumber || !phoneNumber.isValid()) {
    newErrors.phone = "Enter a valid phone number.";
  }
}

    if (!formData.number_of_organizations.trim()) {
      newErrors.number_of_organizations = "Enter a number.";
    } else if (!/^\d+$/.test(formData.number_of_organizations)) {
      newErrors.number_of_organizations = "Only numbers are allowed.";
    }
    if (!formData.number_of_networks.trim()) {
      newErrors.number_of_networks = "Enter a answer.";
    } else if (!/^\d+$/.test(formData.number_of_networks)) {
      newErrors.number_of_networks = "Only numbers are allowed.";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Enter an email address like example@mysite.com.";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address.";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    const payload = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      company: formData.company,
      email: formData.email,
      is_msp: formData.is_msp,
      phone: formData.phone || "",
      number_of_organizations: formData.number_of_organizations,
      number_of_networks:formData.number_of_networks,
      message: formData.message,
      turnstile_token: turnstileToken,
    };

    try {
        const response = await axios.post(
          "https://4jfdbhks2l.execute-api.ap-southeast-2.amazonaws.com/get-quote",
          payload,
          { headers: { "Content-Type": "application/json" } }
        );
    //   console.log(payload);

        if (response.data.result === "Success.") {
          setStatusMessage("Form submitted successfully!");

          setFormData({
            firstName: "",
            lastName: "",
            company: "",
            email: "",
            phone: "",
            is_msp: "",
            number_of_organizations: "",
            number_of_networks: "",
            message: "",
          });
        } else if (response.data.error) {
          setStatusMessage(`Error: ${response.data.message}`);
        } else {
          setStatusMessage("Something went wrong. Please try again.");
        }
    } catch (error) {
      setStatusMessage("Server error. Please try again later.");
      console.error(error);
    }
    setTurnstileKey(turnstileKey + 1);
  };

  return (
    <section className="main-section">
      {/* top section main div */}
      <div className="container">
        <h1 className="main-page-heading text-center">Pricing</h1>
        <p className="subs-para main-para text-center">
          One subscription = one Cisco Meraki organization.
        </p>
        <p className="org-para main-para text-center">
          To include more organizations, add them at checkout or contact us for
          a custom quote.
        </p>
        {/* Cards-main-div */}
        <div className="cards-main-div d-flex">
          {/* card-1 */}
          <div className="col-md-3   card-1-class border rounded mb-5">
            <p className="most-pop-para">Most Popular</p>
            <h4 className="card-1-heading text-center">Premium</h4>
            <p className="per-s-para text-center">
              Perfect for small to medium-sized organizations.
            </p>
            {/* conditional rendring button and price div according to condition*/}
            {seletedValue === "More Network" ? (
              <button className="btn main-btn network-select-btn" type="button" onClick={ScrollToForm}>
                Get a quote
              </button>
            ) : (
              <div className="d-flex align-items-center pricing-main-div justify-content-center">
                <div className="pricing-cal-div">
                  <h4 className="fw-bold mb-0 heading-cal">{price}</h4>
                </div>
                <div
                  className="border-start mx-3 divider-pricing"
                  style={{ height: "79px" }}
                ></div>
                <div className="pricing-content-div">
                  <p className="mb-0 pricing-org-para">per organization</p>
                  <p className="mb-0 pricing-year-para">per year</p>
                </div>
              </div>
            )}
            <p className="select-list-para ">
              Select the size of your organization:
            </p>
            <div className="select-list-div">
              <label className="label-div"></label>
              <select
                value={seletedValue}
                onChange={(e) => {
                  handleChangeSelect(e);
                }}
              >
                <option disabled hidden value=""></option>
                <option value="10">10 networks</option>
                <option value="25">25 networks</option>
                <option value="50">50 networks</option>
                <option value="75">75 networks</option>
                <option value="100">100 networks</option>
                <option value="More Network">More networks</option>
              </select>
            </div>
            <p className="wh-inc-para">What's Included:</p>
            <div className="included-div">
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">
                  Flexible network blocks per organization
                </p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">On-Demand Backup</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Scheduled (Automatic) Backup</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">
                  Automatic Organization-Wide Restore
                </p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Automatic Network-Wide Restore</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Secure Cloud Storage</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Secure API Storage</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Backup History</p>
              </div>
            </div>
            <Link to='https://app.backupmeraki.com/register' target="_blank">
            <button className="btn main-btn start-btn-same "type="button">
              Start Free Trial
            </button></Link>
          </div>
          {/* card-2 */}
          <div className="col-md-3  card-same-class border rounded mb-5">
            <h4 className="card-1-heading text-center">MSP</h4>
            <p className="per-s-para text-center">
              Designed for Managed Service Providers supporting multiple
              organizations at scale.
            </p>
            <button className="btn main-btn" type="button" onClick={ScrollToForm}>
              Get a quote
            </button>
            
            <div className="included-div card-2-class">
            <p className="wh-inc-para">What's Included:</p>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">
                  Flexible network blocks per organization
                </p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">On-Demand Backup</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Scheduled (Automatic) Backup</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">
                  Automatic Organization-Wide Restore
                </p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Automatic Network-Wide Restore</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Secure Cloud Storage</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Secure API Storage</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Backup History</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">
                  Bulk pricing for 5+ organizations
                </p>
              </div>
            </div>
           <Link to='https://app.backupmeraki.com/register' target="_blank">
            <button className="btn main-btn start-btn-same" type="button">
              Start Free Trial
            </button></Link>
          </div>
          {/* card-3 */}
          <div className="col-md-3  card-same-class border rounded mb-5">
            <h4 className="card-1-heading text-center">Enterprise</h4>
            <p className="per-s-para text-center">
              Need something custom? Let’s build a solution for your large-scale
              network environment.
            </p>
            <button className="btn main-btn" type="button" onClick={ScrollToForm}>
              Get a quote
            </button>
            
            <div className="included-div card-2-class">
            <p className="wh-inc-para">What's Included:</p>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">
                  Flexible network blocks per organization
                </p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">On-Demand Backup</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Scheduled (Automatic) Backup</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">
                  Automatic Organization-Wide Restore
                </p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Automatic Network-Wide Restore</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Secure Cloud Storage</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Secure API Storage</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">Backup History</p>
              </div>
              <div className=" d-flex list-inc-div">
                <img src={Tick_image} alt="✔" />
                <p className="list-inc-para">
                  Custom features & Tailored integrations
                </p>
              </div>
            </div>
            <Link to='https://app.backupmeraki.com/register' target="_blank">
            <button className="btn main-btn start-btn-same" type="button">
              Start Free Trial
            </button></Link>
          </div>
        </div>
      </div>
      {/* Get quote section */}
      <section className="four-contact-us py-5" ref={formref}>
        <div className="container">
          <h2 className="four-sec-heading text-center mb-4">Get a quote</h2>

          <div className="row form-outer-div">
            <div className="form-cont-sec">
              <form className="p-4" onSubmit={handleSubmit}>
                {/* full name  */}
                <div className="full-name-div email-phone-div d-flex gap-3">
                  <div className="mb-3 flex-grow-1">
                    <label className="form-label">First Name *</label>
                    <input
                      placeholder="Enter your first name"
                      type="text"
                      name="firstName"
                      className="form-control"
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                    {errors.firstName && (
                      <small className="text-danger">{errors.firstName}</small>
                    )}
                  </div>
                  <div className="mb-3 flex-grow-1">
                    <label className="form-label">Last name *</label>
                    <input
                      placeholder="Enter your last name"
                      type="text"
                      name="lastName"
                      className="form-control"
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                    {errors.lastName && (
                      <small className="text-danger">{errors.lastName}</small>
                    )}
                  </div>
                </div>
                {/* email-phone number div */}
                <div className="email-phone-div d-flex gap-3">
                  <div className="mb-3 flex-grow-1">
                    <label className="form-label">Email *</label>
                    <input
                      placeholder="Enter your email"
                      type="email"
                      name="email"
                      className="form-control"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>
                  <div className="mb-3 flex-grow-1">
                    <label className="form-label">Phone Number</label>
                    <ReactPhoneInput
                      country={"us"}
                      value={formData.phone}
                      onChange={(phone) => {
    setFormData((prev) => ({ ...prev, phone }));

    
    setErrors((prev) => {
      const newErrors = { ...prev };

      if (phone && phone.trim() !== "") {
        try {
          const phoneNumber = parsePhoneNumberFromString("+" + phone);
          if (phoneNumber && phoneNumber.isValid()) {
            delete newErrors.phone;
          }
        } catch (e) {
          
        }
      }

      return newErrors;
    });
  }}
                      inputClass="form-control"
                      enableSearch={true}
                      placeholder="Enter your phone number"
                    />
                    {errors.phone && (
                      <small className="text-danger">{errors.phone}</small>
                    )}
                  </div>
                </div>
                {/* company div */}
                <div className="mb-3">
                  <label className="form-label">Company *</label>
                  <input
                    placeholder="Enter a company name"
                    type="text"
                    name="company"
                    className="form-control"
                    value={formData.company}
                    onChange={handleChange}
                  />
                  {errors.company && (
                    <small className="text-danger">{errors.company}</small>
                  )}
                </div>
                {/* manage service provider div */}
                <div className="mb-3">
                  <label className="form-label">
                    Are you MSP (Managed Services Provider)?*
                  </label>
                  <select
                    name="is_msp"
                    className="form-select"
                    value={formData.is_msp}
                    onChange={handleChange}
                    
                  >
                    <option value="" className="choose-one-class" disabled hidden>Choose one</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  {errors.is_msp && (
                    <small className="text-danger">{errors.is_msp}</small>
                  )}
                </div>
                {/* number_of_organizations div */}
                <div className="mb-3">
                  <label className="form-label">
                    Number of Cisco Meraki Organizations*
                  </label>
                  <input
                    placeholder="Please, specify a number Cisco Meraki Organizations that you need to back up"
                    type="text"
                    name="number_of_organizations"
                    className="form-control"
                    value={formData.number_of_organizations}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d+$/.test(value)) {
                        setFormData((prev) => ({
                          ...prev,
                          number_of_organizations: value,
                        }));
                      }


                      setErrors((prev) => {
        const newErrors = { ...prev };
        if (value.trim() !== "" && /^\d+$/.test(value)) {
          delete newErrors.number_of_organizations;
        }
        return newErrors;
      });
    
                    }}

                    
                    pattern="[0-9]*"
                  />
                  {errors.number_of_organizations && (
                    <small className="text-danger">
                      {errors.number_of_organizations}
                    </small>
                  )}
                </div>
                {/* Number of networks* */}
                <div className="mb-3">
                  <label className="form-label">
                    Number of networks*
                  </label>
                  <input
                    placeholder="Please, specify the number of Networks in you  Cisco Meraki Organization"
                    type="text"
                    name="number_of_networks"
                    className="form-control"
                    value={formData.number_of_networks}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d+$/.test(value)) {
                        setFormData((prev) => ({
                          ...prev,
                          number_of_networks: value,
                        }));
                      }

                      setErrors((prev) => {
        const newErrors = { ...prev };
        if (value.trim() !== "" && /^\d+$/.test(value)) {
          delete newErrors.number_of_networks;
        }
        return newErrors;
      });
                    }}
                    pattern="[0-9]*"
                  />
                  {errors.number_of_networks && (
                    <small className="text-danger">
                      {errors.number_of_networks}
                    </small>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea
                    placeholder="Any additional information"
                    name="message"
                    className="form-control"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    style={{resize:'none'}}
                  ></textarea>
                </div>

                <TurnstileWidget key={turnstileKey} onToken={setTurnstileToken} />

                {statusMessage && (
                  <div
                    className={`mb-3 ${
                      statusMessage.startsWith("Error") ||
                      statusMessage.startsWith("Server")
                        ? "text-danger"
                        : "text-success"
                    }`}
                  >
                    {statusMessage}
                  </div>
                )}

                <button className="btn main-btn w-25" type="submit">
                  Request a quote
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default PricingPage;
